const VideoService = {
  getVideos: async (payload) => {
    const params = Object.keys(payload).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`).join('&');
    const { data, headers } = await ovpFetch(`/video?${params}`);
    const pagination = {
      max_page: 1,
      current_page: payload.page,
    };

    const { link } = headers;
    if (link) {
      const linkSplit = link.split(',');
      const lastIndex = linkSplit.findIndex(rel => rel.includes('rel="last"'));
      const prevIndex = linkSplit.findIndex(rel => rel.includes('rel="prev"'));
      if (lastIndex > -1) {
        pagination.max_page = parseInt(linkSplit[lastIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10);
      } else if (prevIndex > -1) {
        pagination.max_page = parseInt(linkSplit[prevIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10) + 1;
      }
      pagination.current_page = pagination.max_page < pagination.current_page ? pagination.max_page : pagination.current_page;
    }

    return {
      videos: data,
      pagination,
    };
  },
  getVideo: async (id) => {
    const { data } = await ovpFetch(`/video/${id}`);
    return data;
  },
  deleteVideo: async (id) => {
    await ovpFetch(`/video/${id}`, {
      method: 'DELETE',
      iLikeItRaw: true,
    });
    return true;
  },
  uploadPoster: async (id, file) => {
    const { data } = await ovpFetch(`/video/${id}/poster`, {
      method: 'POST',
      body: file,
      defaultContentType: true,
    });
    return data;
  },
  updateVideo: async (id, payload) => {
    const { data } = await ovpFetch(`/video/${id}`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data;
  },
};

// eslint-disable-next-line import/prefer-default-export
export { VideoService };
